import { ModalWrapper } from './styles';

const Modal = (props) => {  
  return (
    <ModalWrapper closable={false} {...props} destroyOnClose />
  )
};

Modal.propTypes = {};

export default Modal;
